export const navLinks = [
  { id: 'topics', label: '热门话题' },
  { id: 'updates', label: '最新快讯' },
  { id: 'media', label: '吃瓜视频' },
  { id: 'index', label: '专题合集' },
  { id: 'about', label: '关于我们' },
  { id: 'comments', label: '瓜友热评' },
];

export const heroStats = [
  { label: '日均更新', value: '200+条' },
  { label: '覆盖领域', value: '12大类' },
  { label: '安全运营', value: '5年+' },
];

export const appEntry = {
  title: '51吃瓜APP — 随时随地吃新鲜瓜',
  subtitle: '支持安卓版、iOS版与轻量版，流畅浏览不卡顿，海量黑料一手掌握',
  imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20floating%20in%20midair%20displaying%20a%20news%20feed%20interface%20with%20trending%20topics%20and%20hot%20labels%2C%20clean%20dark%20UI%20design%20with%20warm%20red%20accents%2C%20minimal%20background%20with%20soft%20gradient%2C%20tech%20product%20photography%2C%20studio%20lighting%2C%20sleek%20and%20modern%20aesthetic&width=600&height=500&seq=app-showcase-01&orientation=portrait',
  badges: [
    { icon: 'ri-android-line', label: '安卓版下载' },
    { icon: 'ri-apple-line', label: 'iOS版下载' },
    { icon: 'ri-smartphone-line', label: '轻量版下载' },
  ],
  features: ['无需注册即看', '极速加载不等待', '每日实时更新', '多端同步收藏'],
};

export const mediaCards = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，狗仔蹲守72小时独家实锤',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20scene%20of%20paparazzi%20photography%2C%20silhouette%20of%20a%20person%20walking%20in%20a%20dimly%20lit%20alley%2C%20warm%20street%20lamp%20glow%2C%20cinematic%20atmosphere%2C%20mysterious%20and%20tense%20mood%2C%20high%20contrast%2C%20film%20noir%20style&width=800&height=450&seq=media-cover-01&orientation=landscape',
    heat: '9.7万',
    duration: '03:25',
    tag: '独家爆料',
  },
  {
    id: 2,
    title: '某当红小花片场耍大牌全记录，工作人员匿名投稿曝光内幕',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20cameras%20and%20equipment%2C%20dramatic%20lighting%20with%20warm%20spotlights%2C%20silhouette%20of%20a%20person%20standing%20center%20stage%2C%20cinematic%20movie%20production%20scene%2C%20tense%20atmosphere%2C%20behind%20the%20scenes%20drama%2C%20warm%20amber%20tones&width=800&height=450&seq=media-cover-02&orientation=landscape',
    heat: '8.2万',
    duration: '05:18',
    tag: '圈内投稿',
  },
  {
    id: 3,
    title: '年度最劲爆塌房事件复盘，从顶流到全网封杀只用了48小时',
    coverUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20shattered%20stage%20with%20broken%20spotlights%2C%20falling%20confetti%2C%20dark%20red%20and%20black%20color%20palette%2C%20theatrical%20dramatic%20scene%2C%20metaphor%20of%20a%20fallen%20star%2C%20cinematic%20lighting%2C%20emotional%20and%20intense%20atmosphere&width=800&height=450&seq=media-cover-03&orientation=landscape',
    heat: '12.4万',
    duration: '08:42',
    tag: '年度盘点',
  },
];

export const indexTopics = [
  {
    id: 1,
    title: '娱乐圈恋情曝光合集',
    desc: '最新明星恋情、约会实锤、恋情官宣全收录',
    icon: 'ri-heart-line',
    count: '128篇',
    hot: true,
  },
  {
    id: 2,
    title: '明星塌房实录',
    desc: '从顶流到小透明，那些年翻车的明星全记录',
    icon: 'ri-close-circle-line',
    count: '96篇',
    hot: true,
  },
  {
    id: 3,
    title: '综艺节目内幕揭秘',
    desc: '热门综艺幕后真相、选手关系、节目骚操作',
    icon: 'ri-tv-line',
    count: '85篇',
  },
  {
    id: 4,
    title: '网红圈大瓜汇总',
    desc: '抖音快手网红翻车、炒作、互撕全知道',
    icon: 'ri-live-line',
    count: '112篇',
  },
  {
    id: 5,
    title: '影视剧拍摄幕后',
    desc: '剧组内幕、演员不合、拍摄事故一手掌握',
    icon: 'ri-film-line',
    count: '73篇',
  },
  {
    id: 6,
    title: '品牌代言风波集',
    desc: '代言翻车、品牌解约、天价代言背后的故事',
    icon: 'ri-vip-crown-line',
    count: '54篇',
    hot: true,
  },
  {
    id: 7,
    title: '海外八卦速递',
    desc: '日韩欧美娱乐圈最新动态，国际瓜也不放过',
    icon: 'ri-global-line',
    count: '67篇',
  },
];

export const faqItems = [
  {
    q: '51吃瓜APP安全吗？会不会有病毒？',
    a: '51吃瓜轻量版与51吃瓜app所有版本均经过严格安全检测，无病毒、无恶意代码。我们采用业界领先的加密传输技术，确保您的个人信息与浏览记录绝对安全。建议通过本页官方渠道下载，避免第三方来源的安全风险。',
  },
  {
    q: '安卓版和iOS版功能有什么区别？',
    a: '两个版本核心功能完全一致，均可浏览全部吃瓜内容。安卓版支持更多自定义设置选项，iOS版在流畅度和界面动画上略有优势。轻量版则针对低配手机和弱网环境做了极致优化，安装包仅8MB。',
  },
  {
    q: '轻量版和完整版有什么区别？',
    a: '51吃瓜轻量版专为存储空间有限或网络环境不稳定的用户设计。相比完整版app，轻量版去除了一些非核心的动画效果和缓存机制，但保留了全部内容浏览、搜索和收藏功能，流量消耗更低，加载更快。',
  },
  {
    q: '每天什么时候更新内容？',
    a: '我们的编辑团队7×24小时不间断追踪最新八卦动态。通常上午10点、下午3点和晚上9点是三个主要更新时段，突发大瓜随时加更推送。开启APP通知权限即可第一时间收到爆瓜提醒。',
  },
];

export const topicTags = [
  { id: 1, name: '顶流塌房', heat: '126.8万', trend: 'up', color: 'primary' },
  { id: 2, name: '恋情实锤', heat: '98.3万', trend: 'up', color: 'accent' },
  { id: 3, name: '综艺撕逼', heat: '87.6万', trend: 'hot', color: 'primary' },
  { id: 4, name: '导演爆料', heat: '72.1万', trend: 'up', color: 'secondary' },
  { id: 5, name: '品牌翻车', heat: '65.4万', trend: 'down', color: 'accent' },
  { id: 6, name: '剧组内幕', heat: '58.9万', trend: 'up', color: 'secondary' },
  { id: 7, name: '网红互撕', heat: '53.2万', trend: 'hot', color: 'primary' },
  { id: 8, name: '选秀黑幕', heat: '47.8万', trend: 'down', color: 'accent' },
  { id: 9, name: '海外八卦', heat: '41.5万', trend: 'up', color: 'secondary' },
];

export const contactInfo = {
  title: '有料你就来 — 吃瓜投稿通道',
  desc: '我们欢迎每一位知情人、圈内人、热心瓜友提供线索。你的投稿将经过编辑团队核实后发布，严格保护投稿人隐私，绝不透露任何个人信息。',
  email: 'tougao@51chigua.example.com',
  tips: ['匿名投稿，身份绝对保密', '提供证据材料优先处理', '重大独家线索有酬谢'],
};

export const infoCards = [
  {
    id: 1,
    title: '独家：某知名导演被曝潜规则多名女演员，聊天记录流出',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20director%20chair%20empty%20on%20a%20darkened%20film%20set%2C%20spotlight%20casting%20long%20shadows%2C%20warm%20amber%20and%20crimson%20lighting%2C%20cinematic%20photography%2C%20mysterious%20and%20tense%20atmosphere%2C%20film%20noir%20style&width=800&height=500&seq=card-img-01&orientation=landscape',
    tag: '独家报道',
    time: '2小时前',
    heat: '15.6万',
  },
  {
    id: 2,
    title: '某女团成员被拍到与富二代深夜同回公寓，粉丝集体破防',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20apartment%20building%20entrance%20at%20night%2C%20soft%20warm%20light%20spilling%20from%20glass%20doors%2C%20silhouette%20of%20two%20people%20walking%20together%2C%20paparazzi%20style%20photography%2C%20romantic%20yet%20mysterious%20mood%2C%20urban%20night%20scene&width=800&height=500&seq=card-img-02&orientation=landscape',
    tag: '恋情曝光',
    time: '5小时前',
    heat: '12.8万',
  },
  {
    id: 3,
    title: '某选秀节目投票造假证据曝光，制作方连夜开会应对危机',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20conference%20room%20with%20scattered%20documents%20on%20a%20table%2C%20dim%20warm%20lighting%2C%20silhouette%20of%20people%20in%20intense%20discussion%2C%20dramatic%20corporate%20crisis%20scene%2C%20cinematic%20lighting%2C%20tense%20atmosphere&width=800&height=500&seq=card-img-03&orientation=landscape',
    tag: '选秀黑幕',
    time: '8小时前',
    heat: '10.3万',
  },
  {
    id: 4,
    title: '知名品牌代言人突然被解约，知情人透露背后另有隐情',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20taken%20down%20at%20night%2C%20workers%20on%20scaffolding%2C%20dramatic%20urban%20scene%2C%20warm%20street%20lights%2C%20cinematic%20photography%2C%20sense%20of%20sudden%20change%20and%20uncertainty&width=800&height=500&seq=card-img-04&orientation=landscape',
    tag: '品牌风波',
    time: '12小时前',
    heat: '9.6万',
  },
  {
    id: 5,
    title: '某综艺录制现场突发意外，嘉宾当场翻脸罢录走人',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20empty%20chairs%20and%20cameras%2C%20warm%20studio%20lighting%2C%20signs%20of%20sudden%20disruption%2C%20scattered%20props%2C%20dramatic%20behind%20the%20scenes%20moment%2C%20cinematic%20composition&width=800&height=500&seq=card-img-05&orientation=landscape',
    tag: '综艺事故',
    time: '1天前',
    heat: '8.4万',
  },
  {
    id: 6,
    title: '某演员税务问题再起波澜，工作室发声明紧急辟谣',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20formal%20press%20conference%20room%20with%20empty%20podium%20and%20microphones%2C%20dramatic%20lighting%2C%20official%20statement%20atmosphere%2C%20warm%20amber%20tones%2C%20corporate%20crisis%20communication%20scene%2C%20cinematic%20photography&width=800&height=500&seq=card-img-06&orientation=landscape',
    tag: '税务风波',
    time: '1天前',
    heat: '7.9万',
  },
];

export const aboutInfo = {
  title: '关于51吃瓜黑料网',
  paragraphs: [
    '51吃瓜黑料网成立于2019年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最劲爆的娱乐圈八卦资讯，涵盖明星恋情、综艺内幕、影视黑料、网红翻车等多个领域。',
    '我们的编辑团队由资深娱记和资深吃瓜群众组成，7×24小时不间断追踪各大平台的最新动态，确保你不错过任何一个热乎的瓜。无论是顶流塌房还是十八线小透明的精彩故事，51吃瓜黑料网都给你安排得明明白白。',
    '为满足不同用户的需求，我们推出了51吃瓜轻量版与51吃瓜app，支持安卓版、iOS版多平台使用。轻量版安装包仅8MB，极速加载省流量；完整版app功能更全面，支持离线缓存和推送通知，随时随地看八卦。',
  ],
  features: ['海量八卦一手掌握', '极速更新不等待', '多端同步随时看', '安全浏览无痕迹'],
};

export const updateItems = [
  {
    id: 1,
    date: '07-30',
    title: '某顶流小生被拍到与女经纪人牵手逛街，工作室回应"只是工作关系"',
    tag: '恋情',
    hot: true,
  },
  {
    id: 2,
    date: '07-30',
    title: '某综艺节目录制现场嘉宾发生激烈争吵，导演组紧急暂停录制',
    tag: '综艺',
    hot: true,
  },
  {
    id: 3,
    date: '07-29',
    title: '某品牌官宣新代言人，原代言人粉丝集体抵制引发网络热议',
    tag: '代言',
  },
  {
    id: 4,
    date: '07-29',
    title: '某知名导演新片选角内幕曝光，带资进组演员被群嘲演技拉胯',
    tag: '影视',
  },
  {
    id: 5,
    date: '07-28',
    title: '某女星直播带货翻车，产品效果与宣传严重不符遭消费者投诉',
    tag: '翻车',
    hot: true,
  },
  {
    id: 6,
    date: '07-28',
    title: '某男团成员被爆私联粉丝，聊天记录尺度惊人，粉丝后援会宣布解散',
    tag: '偶像',
  },
  {
    id: 7,
    date: '07-27',
    title: '某电视剧拍摄现场发生安全事故，主演受伤送医，剧组发布致歉声明',
    tag: '事故',
  },
  {
    id: 8,
    date: '07-27',
    title: '某网红被同行实名举报偷税漏税，税务局已介入调查',
    tag: '法制',
  },
  {
    id: 9,
    date: '07-26',
    title: '某音乐节主办方跑路，多位艺人演出费未结，联合发声明维权',
    tag: '维权',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '2024娱乐圈年度塌房报告',
    desc: '从年初到年尾，盘点那些让你惊掉下巴的明星翻车事件，哪一件最让你意外？',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20with%20falling%20stars%20and%20shattered%20spotlights%2C%20dark%20red%20and%20black%20color%20scheme%2C%20theatrical%20metaphor%20for%20fallen%20celebrities%2C%20cinematic%20lighting%2C%20dramatic%20and%20intense%20atmosphere%2C%20abstract%20concept%20photography&width=1000&height=560&seq=carousel-01&orientation=landscape',
    tag: '年度专题',
    count: '48篇',
  },
  {
    id: 2,
    title: '韩娱圈大地震：那些被实锤的爱豆',
    desc: '韩国娱乐圈接连曝出重磅丑闻，涉及多位一线爱豆，韩娱粉丝圈彻底炸锅。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cracked%20K-pop%20style%20stage%20with%20neon%20lights%20flickering%2C%20dark%20and%20moody%20atmosphere%2C%20broken%20microphone%20stand%2C%20dramatic%20shadows%2C%20symbolic%20of%20scandal%20and%20downfall%2C%20cinematic%20photography&width=1000&height=560&seq=carousel-02&orientation=landscape',
    tag: '韩娱专题',
    count: '36篇',
  },
  {
    id: 3,
    title: '网红圈乱象大起底：割韭菜套路全解析',
    desc: '从带货翻车到人设崩塌，网红圈的割韭菜套路比你想象的还要深。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20studio%20with%20ring%20lights%20turned%20off%2C%20smartphone%20on%20tripod%20showing%20error%20screen%2C%20scattered%20products%20on%20a%20table%2C%20metaphor%20for%20livestream%20failure%2C%20dramatic%20warm%20lighting%2C%20cinematic%20composition&width=1000&height=560&seq=carousel-03&orientation=landscape',
    tag: '深度调查',
    count: '25篇',
  },
  {
    id: 4,
    title: '那些年我们追过的CP：真情侣or营业咖？',
    desc: '娱乐圈CP大盘点，哪些是真情流露，哪些只是商业炒作？吃瓜群众来鉴定。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20spotlights%20crossing%20on%20a%20dark%20stage%2C%20one%20warm%20amber%20and%20one%20cool%20white%2C%20symbolic%20of%20questionable%20relationships%2C%20dramatic%20theater%20atmosphere%2C%20cinematic%20lighting%2C%20romantic%20yet%20uncertain%20mood&width=1000&height=560&seq=carousel-04&orientation=landscape',
    tag: 'CP盘点',
    count: '52篇',
  },
  {
    id: 5,
    title: '综艺节目剧本曝光：你以为的真实全是演的',
    desc: '多位前综艺工作人员匿名爆料，揭秘那些精心设计的"意外"和"巧合"。',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20control%20room%20with%20multiple%20monitors%20showing%20different%20angles%2C%20script%20papers%20scattered%2C%20dramatic%20lighting%2C%20behind%20the%20scenes%20reveal%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20documentary%20style&width=1000&height=560&seq=carousel-05&orientation=landscape',
    tag: '幕后揭秘',
    count: '31篇',
  },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时不间断追踪，突发大瓜5分钟内推送，永远比别人快一步吃到新鲜瓜。51吃瓜轻量版更支持省流量模式，弱网环境也能流畅浏览。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '51吃瓜app全版本经过安全检测，无病毒无恶意代码。加密传输保护隐私，浏览记录本地存储不上传，让你安心吃瓜无后顾之忧。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持安卓版、iOS版、轻量版多平台使用，收藏和浏览记录云端同步，换设备也不丢失。51吃瓜下载安装简单，即装即用。',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，狗仔72小时蹲守实锤', heat: '28.6万', trend: 'up', isNew: true },
  { rank: 2, title: '某女团成员与富二代同回公寓，粉丝集体破防脱粉', heat: '24.1万', trend: 'up', isNew: true },
  { rank: 3, title: '选秀节目投票造假证据曝光，制作方连夜开会', heat: '21.8万', trend: 'up', isNew: false },
  { rank: 4, title: '知名导演被曝潜规则女演员，聊天记录流出', heat: '19.3万', trend: 'down', isNew: false },
  { rank: 5, title: '品牌代言人突遭解约，知情人士透露另有隐情', heat: '17.5万', trend: 'up', isNew: false },
  { rank: 6, title: '综艺录制现场嘉宾翻脸罢录，场面一度失控', heat: '15.2万', trend: 'down', isNew: false },
  { rank: 7, title: '某演员税务问题再起波澜，工作室紧急辟谣', heat: '13.7万', trend: 'up', isNew: true },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20cartoon%20style%20watermelon%20character%20avatar%2C%20cute%20and%20playful%2C%20minimal%20design%2C%20warm%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    nickname: '资深吃瓜人',
    time: '3小时前',
    content: '这个瓜我吃了三天了，越吃越有味道。只能说贵圈真乱，某些人设崩塌得比我想象的还要彻底。期待后续更多实锤！',
    likes: 3268,
    tag: '热评',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20cartoon%20style%20melon%20slice%20character%20avatar%2C%20funny%20and%20expressive%2C%20minimal%20design%2C%20warm%20red%20and%20green%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    nickname: '不八卦会死星人',
    time: '5小时前',
    content: '我就是冲着51吃瓜app下载来的，轻量版用了两个月了，更新速度确实快。每天早上起来第一件事就是打开看有没有新瓜，比刷微博还勤快！',
    likes: 2156,
    tag: '忠实用户',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20cartoon%20style%20sunglasses%20emoji%20character%20avatar%2C%20cool%20and%20mysterious%2C%20minimal%20design%2C%20dark%20warm%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    nickname: '圈内边缘人',
    time: '8小时前',
    content: '有些料我作为半个圈内人都不知道，这信息来源也太广了。不过建议大家理性吃瓜，有些明显是炒作的就当乐子看，别太真情实感。',
    likes: 1892,
    tag: '理性吃瓜',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=A%20cartoon%20style%20popcorn%20character%20avatar%2C%20excited%20and%20happy%2C%20minimal%20design%2C%20warm%20yellow%20and%20white%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    nickname: '吃瓜第一线',
    time: '12小时前',
    content: '51吃瓜黑料网真的是我每天的快乐源泉！轻量版安装包小不占内存，但内容一点不打折。现在已经安利给整个办公室的同事了，大家都成了忠实瓜友。',
    likes: 1456,
    tag: '自来水',
  },
];

export const footerLinks = {
  sections: [
    {
      title: '快速导航',
      links: ['热门话题', '最新快讯', '吃瓜视频', '专题合集', '热度榜单'],
    },
    {
      title: '下载入口',
      links: ['51吃瓜安卓版', '51吃瓜iOS版', '51吃瓜轻量版', '版本更新日志', '安装教程'],
    },
    {
      title: '关于我们',
      links: ['平台介绍', '投稿通道', '内容声明', '隐私政策', '免责声明'],
    },
  ],
  bottom: '51吃瓜黑料网 - 51吃瓜轻量版与51吃瓜app下载 | 内容仅供娱乐，请理性吃瓜。本站所有内容均来自用户投稿与公开信息整理，不代表本站立场。',
};